
(function () {
	if (window.__lazyVidInit) return;
	window.__lazyVidInit = 1;
	function initLazyVideos() {
		var vids = document.querySelectorAll('video[data-lazy-autoplay]');
		if (!vids.length) return;
		var playVid = function (v) {
			v.muted = true;
			var p = v.play();
			if (p && p.catch) p.catch(function () {});
		};
		if (!('IntersectionObserver' in window)) {
			for (var i = 0; i < vids.length; i++) playVid(vids[i]);
			return;
		}
		var io = new IntersectionObserver(function (entries) {
			entries.forEach(function (e) {
				if (e.isIntersecting) {
					playVid(e.target);
					io.unobserve(e.target);
				}
			});
		}, { rootMargin: '300px 0px' });
		for (var j = 0; j < vids.length; j++) io.observe(vids[j]);
	}
	if (document.readyState !== 'loading') initLazyVideos();
	else document.addEventListener('DOMContentLoaded', initLazyVideos);
})();
